import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';
import mutateProps from 'utils/mutateProps';

import {selectAllocation} from 'api/allocations';
import {STATUS} from 'api/utils';

import {query, mutation, signProps, signedInvestAgreement as signed} from 'flows/invest/agree/index';
import Spinner from 'components/Spinner';

import InvestAgreement from './component';

export class InvestAgreementContainer extends React.Component {
  constructor() {
    super();
    this.next = this.next.bind(this);
  }
  next() {
    const {params: {allocationId, after, confirm}, sign, signed, data: { allocation }} = this.props;

    return this.props.sign()
      .then(() => signed({
        id: allocationId,
        confirmationToast: confirm,
        after,
        allocation,
      }));
  }
  render() {
    const {signLoading} = this.props;
    const {allocation, loading} = this.props.data || {};

    if (loading || !allocation || signLoading) {
      return (
        <Spinner />
      );
    }
    return (
      <InvestAgreement next={this.next} allocation={allocation} />
    );
  }
}

InvestAgreementContainer.propTypes = {
  sign: PropTypes.func.isRequired,
  signLoading: PropTypes.bool.isRequired,
  signed: PropTypes.func.isRequired,
  data: PropTypes.shape({
    allocation: PropTypes.object,
    loading: PropTypes.bool.isRequired,
  }),
  params: PropTypes.shape({
    allocationId: PropTypes.string.isRequired,
    after: PropTypes.string.isRequired,
    confirm: PropTypes.string.isRequired,
  }).isRequired,
};

const mapPropsToOptions = ({params: {allocationId}}) => ({
  variables: {
    allocationId,
  }
});

const mapMutation = props => ({
  sign: signProps(props),
});

export default compose(
  connect(null, {signed}),
  graphql(query, {
    options: mapPropsToOptions
  }),
  graphql(mutation, {
    props: mapMutation,
  }),
  mutateProps({name: 'sign'}),
)(InvestAgreementContainer);



// WEBPACK FOOTER //
// ./web/flows/invest/agreement/index.js